<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-6xl mx-4 sm:mx-6">
  <div class="p-6 sm:p-8">

    @if (error) {
      <div class="mb-4 rounded-lg bg-red-50 dark:bg-red-900/20 p-3 text-sm text-red-700 dark:text-red-300">{{ error }}</div>
    }

    @if (loading) {
      <div class="space-y-3">
        <div class="h-20 animate-pulse rounded-xl bg-gray-100 dark:bg-gray-800"></div>
        <div class="h-10 animate-pulse rounded-xl bg-gray-100 dark:bg-gray-800"></div>
        <div class="h-48 animate-pulse rounded-xl bg-gray-100 dark:bg-gray-800"></div>
      </div>
    } @else if (campaign) {

      <!-- ══ HEADER ══ -->
      <div class="mb-6">
        <!-- Acciones (arriba a la derecha) -->
        <div class="mb-4 flex flex-wrap justify-end gap-2">
          <button (click)="reload()" title="Refrescar"
                  class="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
            <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h5M20 20v-5h-5M4 9a9 9 0 0114-3.5M20 15a9 9 0 01-14 3.5"></path>
            </svg>
            Refrescar
          </button>
          @if (campaign.status === 'DRAFT' || campaign.status === 'SCHEDULED') {
            <button *appHasPermission="'campaigns:edit'" (click)="edit()"
                    class="inline-flex items-center gap-1.5 rounded-lg border border-gray-300 dark:border-gray-700 px-3 py-2 text-sm text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
              </svg>
              Editar
            </button>
            <button *appHasPermission="'campaigns:edit'" (click)="cancelCampaign()"
                    class="inline-flex items-center gap-1.5 rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 px-3 py-2 text-sm text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors">
              Cancelar
            </button>
          }
          @if (canMarkFailed) {
            <button *appHasPermission="'campaigns:edit'" (click)="markFailed()" [disabled]="markingFailed"
                    title="Destrabar un correo atascado enviando"
                    class="inline-flex items-center gap-1.5 rounded-lg border border-amber-300 dark:border-amber-700 bg-amber-50 dark:bg-amber-900/20 px-3 py-2 text-sm text-amber-700 dark:text-amber-300 hover:bg-amber-100 dark:hover:bg-amber-900/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              @if (markingFailed) {
                <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              } @else {
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01M5.07 19h13.86a2 2 0 001.74-3L13.74 4a2 2 0 00-3.48 0L3.33 16a2 2 0 001.74 3z"></path>
                </svg>
              }
              Destrabar / Marcar como fallido
            </button>
          }
          @if (canResendFailed) {
            <button *appHasPermission="'campaigns:edit'" (click)="resendFailed()" [disabled]="resending" title="Reencolar destinatarios fallidos"
                    class="inline-flex items-center gap-1.5 rounded-lg border border-teal-300 dark:border-teal-700 bg-teal-50 dark:bg-teal-900/20 px-3 py-2 text-sm text-teal-700 dark:text-teal-300 hover:bg-teal-100 dark:hover:bg-teal-900/40 transition-colors disabled:opacity-50 disabled:cursor-not-allowed">
              @if (resending) {
                <svg class="h-4 w-4 animate-spin" fill="none" viewBox="0 0 24 24">
                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                  <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
              } @else {
                <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 4v5h5M20 20v-5h-5M4 9a9 9 0 0114-3.5M20 15a9 9 0 01-14 3.5"></path>
                </svg>
              }
              Reenviar fallidos
            </button>
          }
          @if (campaign.status !== 'SENDING') {
            <button *appHasPermission="'campaigns:delete'" (click)="deleteCampaign()"
                    class="inline-flex items-center gap-1.5 rounded-lg border border-red-300 dark:border-red-700 px-3 py-2 text-sm text-red-700 dark:text-red-300 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors">
              <svg class="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6M1 7h22M9 7V4a2 2 0 012-2h2a2 2 0 012 2v3"></path>
              </svg>
              Eliminar
            </button>
          }
        </div>

        <!-- Identidad: avatar + estado + nombre + asunto + responsable -->
        <div class="flex items-start gap-6">
          <div class="flex-shrink-0">
            <div class="flex h-20 w-20 items-center justify-center rounded-full {{ avatarColorClass }}">
              <span class="text-2xl font-semibold">{{ initials }}</span>
            </div>
          </div>

          <div class="min-w-0 flex-1">
            <div class="flex flex-wrap items-center gap-2.5">
              <span class="rounded-full px-2.5 py-0.5 text-xs font-semibold" [class]="statusBadgeClass(campaign.status)">
                {{ statusLabel(campaign.status) }}
              </span>
              @if (showRefreshingBadge) {
                <span class="inline-flex items-center gap-1 text-xs text-amber-600 dark:text-amber-300">
                  <svg class="h-3 w-3 animate-spin" fill="none" viewBox="0 0 24 24">
                    <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                    <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                  </svg>
                  Actualizando…
                </span>
              }
            </div>
            <h2 class="mt-1.5 text-2xl font-bold text-gray-900 dark:text-white truncate">{{ campaign.name }}</h2>
            @if (campaign.subject) {
              <p class="mt-1 text-sm text-gray-600 dark:text-gray-400 truncate">{{ campaign.subject }}</p>
            }
          </div>

          <div class="mt-auto flex flex-shrink-0 items-center gap-2">
            <span class="text-sm font-medium text-gray-700 dark:text-gray-300">Responsable:</span>
            @if (loadingOwner) {
              <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-brand-500"></div>
            } @else if (ownerName) {
              <span class="text-sm font-medium text-gray-900 dark:text-white">{{ ownerName }}</span>
            } @else {
              <span class="text-sm text-gray-400 dark:text-gray-500">Sin información</span>
            }
          </div>
        </div>
      </div>

      <!-- ══ TABS ══ -->
      <app-campaign-detail-tabs
        [campaign]="campaign"
        [metrics]="metrics"
        [lists]="lists"
        [segments]="segments"
        [manualRecipients]="manualRecipients"
        [excludedContacts]="excludedContacts"
        [excludedSegments]="excludedSegments"
        [activeTab]="activeTab"
        (tabChange)="onTabChange($event)"
        (editRequested)="edit()">
      </app-campaign-detail-tabs>

      <!-- Cerrar (abajo a la derecha) -->
      <div class="mt-6 flex justify-end border-t border-gray-200 dark:border-gray-700 pt-4">
        <button type="button" (click)="onClose()"
                class="rounded-lg border border-gray-300 dark:border-gray-600 px-5 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-800 transition-colors">
          Cerrar
        </button>
      </div>
    }
  </div>
</app-modal>
